const createType = (perfix: string) => {
    return {
        REQUEST: perfix + '_REQUEST',
        SUCCESS: perfix + '_SUCCESS',
        FAILED: perfix + '_FAILED'
    };
};

export const GET_SYSTEMCONFIG_NAME = createType('GET_SYSTEMCONFIG_NAME');
export const GET_LEFT_SYSTEMCONFIG_NAME = createType('GET_LEFT_SYSTEMCONFIG_NAME');
export const GET_FOLDER_FILES_NAME = createType('GET_FOLDER_FILES_NAME');
